import { render, staticRenderFns } from "./ManageSurvey.vue?vue&type=template&id=40461e80&"
import script from "./ManageSurvey.vue?vue&type=script&lang=js&"
export * from "./ManageSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports